import React from 'react'
import { AmchartSeeker } from "@ui-seeker/core"
import { Skeleton } from "@mui/material"
import {formatDate, postExcel} from "@ui-seeker/utils";
import {BACKEND_APIS} from "../../../../@constants";
import {analyzerFilters} from "../../../AnalyzersV2/@signals";
import {companyUsers, dateRange, userData} from "../../../../@signals";


export default function SearchAnalyticsColumnsChart({ data, isMonthLoading }) {

	if (isMonthLoading) return <Skeleton variant="rectangular" height={500}/>

	return <AmchartSeeker
		title="Daily searches vs Previous Month"
		rootID="SearchAnalyticsBarChart"
		data={data?.results}
		sx={{ height: 400 }}
		series={data?.series?.map(({ dataKey, label, color }) => {
			const key = dataKey === "searches" ? "date" : "previousDate"
			const value = dataKey === "searches" ? "searches" : "previousSearches"
			return {
				type: "column",
				name: label,
				yField: dataKey,
				xField: 'date',
				color: color,
				tooltip: {
					isDateAxis: true,
					tooltipVisibleOnZero: true,
					labelText: `[bold]{${key}.formatDate('dd MMM yyyy')}:[/] {${value}.formatNumber('#,###')}`
				}
			}
		})}
		chartProps={{
			enabledPDF: false,
			dateFormatReceived: 'yyyy-MM-dd',
			xAxis: {
				title: "Dates",
				categoryField: 'date',
				isDateAxis: true,
				dateFormat: 'dd MMM yyyy',
				baseInterval: {
					timeUnit: 'day',
					count: 1
				},
				hiddenTooltip: true
			},
			yAxis: {
				title: 'N° of Searches'
			},
		}}
	/>
}